import React from 'react';
import RadioButton from './RadioButton';
import AsLabel from './AsLabel';
import Spacer from './Spacer';
import Flex from './containers/Flex';
import PropTypes from 'prop-types';

const LabelledRadioButton = ({
    id = 'labelled-radio-button',
    name,
    title,
    gap,
    labelStyle,
    reverseElements = false,
    disabled = false,
    ...props
}) => {
    return (
        <Flex centreVertical>
            {reverseElements ? (
                <React.Fragment>
                    <RadioButton
                        {...props}
                        id={id}
                        name={name}
                        disabled={disabled}
                    />
                    {gap && <Spacer width={gap} />}
                    <AsLabel name={name} style={labelStyle}>
                        {title}
                    </AsLabel>
                </React.Fragment>
            ) : (
                <React.Fragment>
                    <AsLabel name={name} style={labelStyle}>
                        {title}
                    </AsLabel>
                    {gap && <Spacer width={gap} />}
                    <RadioButton
                        {...props}
                        id={id}
                        name={name}
                        disabled={disabled}
                    />
                </React.Fragment>
            )}
        </Flex>
    );
};

LabelledRadioButton.defaultProps = {
    id: 'labelled-tickbox',
    reverseElements: false,
    disabled: false
};

LabelledRadioButton.propTypes = {
    // Labelled Radio Button
    id: PropTypes.string,
    title: PropTypes.string,
    labelStyle: PropTypes.object,
    gap: PropTypes.number,
    name: PropTypes.string,
    reverseElements: PropTypes.bool,
    // Radio Button
    initialValue: PropTypes.bool,
    value: PropTypes.any,
    onClick: PropTypes.func,
    disabled: PropTypes.any,
    activeStyle: PropTypes.object,
    inactiveStyle: PropTypes.object,
    disabledStyle: PropTypes.object,
    checkStyle: PropTypes.object,
    style: PropTypes.object
};

export default LabelledRadioButton;
